export default "/images/e41ac83fdad4590034b308e66aa946b7.avif";